import { IconProps } from "src/types/IconType";

const ArrowDropUpIcon = ({ width, height, color = "#333236" }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.51936 0.645511L8.93308 4.0592C8.98017 4.10629 9.01725 4.15887 9.04434 4.21694C9.07142 4.27502 9.08496 4.33725 9.08496 4.40362C9.08496 4.53637 9.04007 4.6517 8.9503 4.74961C8.86055 4.84753 8.74224 4.89648 8.59538 4.89648L1.40378 4.89648C1.25691 4.89648 1.1386 4.84706 1.04885 4.7482C0.959077 4.64933 0.914191 4.53399 0.914191 4.40218C0.914191 4.36922 0.964891 4.25482 1.06629 4.05898L4.47979 0.645483C4.55826 0.567014 4.63938 0.509723 4.72314 0.473612C4.80691 0.437501 4.89906 0.419446 4.99958 0.419446C5.10009 0.419446 5.19224 0.437501 5.27602 0.473612C5.35978 0.509723 5.44089 0.567023 5.51936 0.645511Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowDropUpIcon;
